import { CONTENT_TYPE } from "../constants";

export function getFileType(file: File) {
  const { type } = file;

  const image = /^(image)/i;
  const imageMatch = image.test(type);

  if (imageMatch) {
    return CONTENT_TYPE.PHOTO;
  }

  const audio = /^(audio)/i;
  const audioMatch = audio.test(type);

  if (audioMatch) {
    return CONTENT_TYPE.AUDIO;
  }

  if (type === "application/pdf") {
    return CONTENT_TYPE.PDF;
  }

  return null;
}

export function getFileNameWithoutExt(fileName: string) {
  return fileName.split(".").slice(0, -1).join(".");
}

export function getFileExt(fileName: string) {
  const a = fileName.split(".");
  if (a.length === 1 || (a[0] === "" && a.length === 2)) {
    return "";
  }
  return a.pop()?.toLowerCase();
}

export function humanFileSize(bytes: number, si: boolean) {
  let newBytes = bytes;
  if (typeof newBytes !== "number") {
    return newBytes;
  }

  const thresh = si ? 1000 : 1024;
  if (Math.abs(newBytes) < thresh) {
    return `${newBytes} B`;
  }
  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  do {
    newBytes /= thresh;
    ++u;
  } while (Math.abs(newBytes) >= thresh && u < units.length - 1);
  return `${newBytes.toFixed(1)}${units[u]}`;
}
